<template>
  <div id="index" ref="appRef">
    <div class="count-main">
      <img class="count-main-title" src="../../assets/images/pagelogo.png" alt="" />
      <div class="count-main-time">
        <img class="img-top" src="../../assets/images/next.png" alt="" />
        <!-- <img class="img-center" src="../../assets/images/time.png" alt="" /> -->
        <div class="count-main-time-text" style="font-size: 62px;">2026年7月12日 08:30:00</div>
        <!-- <div>还剩xxx天xx小时xx分xx秒</div> -->
        <div>还剩{{ this.surplusTimer }}</div>
      </div>
      <img class="count-main-senparc" src="../../assets/images/Senparc.png" alt="" />
    </div>
  </div>
</template>

<script>
import drawMixin from '@/utils/drawMixin'
export default {
  mixins: [drawMixin],
  data() {
    return {
      surplusTimer: null,
      timing: null
    }
  },
  created() {
    this.getTimer()
  },
  beforeDestroy() {
    clearInterval(this.timing)
  },
  methods: {
    getTimer() {
      // getTime() 获取的时间戳是毫秒级 封装的方法是秒级 需要处理为秒级
      // 目标时间
      const targetTime = new Date('2026/07/12 08:30:00').getTime()
      this.targetTime = targetTime
      this.timing = setInterval(() => {
        // 当前时间
        const currentTime = new Date().getTime()
        if (currentTime < this.targetTime) {
          // 时间差
          const timeDifference = (this.targetTime - currentTime) / 1000
          // 剩余时间
          this.surplusTimer = this.dayTosecondToHour(timeDifference)
        } else {
          this.surplusTimer = '0天0时0分0秒'
          clearInterval(this.timing)
        }
        // console.log('surplusTimer',this.surplusTimer);
      }, 1000)
    },
    // 剩余时间处理
    dayTosecondToHour(msd) {
      // parseInt 可解析一个字符串，并返回一个整数。
      var time = msd
      var second = parseInt(time) // 秒
      var minute = 0 // 分
      var hour = 0 // 小时
      var day = 0 // 天
      if (second > 60) {
        minute = parseInt(second / 60) || 0
        second = parseInt(second % 60) || 0
        if (minute > 60) {
          hour = parseInt(minute / 60) || 0
          minute = parseInt(minute % 60) || 0
          if (hour > 24) {
            day = parseInt(hour / 24) || 0
            hour = parseInt(hour % 24) || 0
          }
        }
      }
      var result = '' + parseInt(second) + '秒'
      if (minute > 0) {
        result = '' + parseInt(minute) + '分' + result
      }
      if (hour > 0) {
        result = '' + parseInt(hour) + '时' + result
      }
      if (day > 0) {
        result = '' + parseInt(day) + '天' + result
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
  #index {
    color: #d3d6dd;
    width: 1920px;
    height: 1080px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transform-origin: left top;
    overflow: hidden;

    .count-main {
      background: url(../../assets/images/pageBg.png);
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      padding: 20px;
      .count-main-title {
        width: 892px;
        height: 153px;
      }
      .count-main-time {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        height: 600px;

        .img-top {
          width: 1147px;
          max-height: 347px;
        }
        .img-center {
          width: 868px;
          height: 64px;
          // padding: 20px 0;
        }

        div {
          width: 1777px;
          height: 137px;
          font-size: 129px;
          color: #191746;
          line-height: 155px;
          text-align: center;
          font-family: 'ruizi';
        }
      }
      .count-main-senparc {
        width: 302px;
        height: 128px;
      }
    }
  }
</style>
